import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'

/** Una fila de la sección Grandes Empresas. */
export interface FilaGE {
  contactId: string
  nombre: string
  cif: string
  poblacion: string
  telefono: string
  ultimoReparto: string | null
  recurrenciaDias: number | null
}

interface RespuestaGE {
  items: FilaGE[]
  total: number
}

export type OrdenGE = 'ultimo_reparto' | 'poblacion'

/** Lista de clientes GE, ordenable por último reparto o población. */
export function useGrandesEmpresas(orden: OrdenGE = 'ultimo_reparto') {
  const api = useApi()
  return useQuery<RespuestaGE, ErrorApi>({
    queryKey: ['ge', orden],
    queryFn: ({ signal }) =>
      api.pedir<RespuestaGE>('/api/ge', { senal: signal, parametros: { orden } }),
  })
}

/** Fija la recurrencia (7/14/28 o null) de un GE. */
export function useFijarRecurrencia() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation<FilaGE, ErrorApi, { contactId: string; dias: number | null }>({
    mutationFn: ({ contactId, dias }) =>
      api.pedir<FilaGE>(`/api/ge/${contactId}/recurrencia`, {
        metodo: 'POST',
        cuerpo: { dias },
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['ge'] })
    },
  })
}
